const DEFAULT_CONTEXT = 'Logger';
const DEFAULT_LOG_LEVEL = 'warn';
const LOG_LEVELS = ['debug', 'info', 'warn', 'error'] as const;

type LogLevel = (typeof LOG_LEVELS)[number];

/**
 * Utility class for logging messages with different log levels.
 */
class LoggingUtil {
  private context: string;
  private logLevel: LogLevel;

  constructor(
    context = DEFAULT_CONTEXT,
    logLevel: LogLevel = DEFAULT_LOG_LEVEL,
  ) {
    this.context = context;
    this.logLevel = logLevel;
  }

  private shouldLog(level: LogLevel): boolean {
    return LOG_LEVELS.indexOf(level) >= LOG_LEVELS.indexOf(this.logLevel);
  }

  log(level: LogLevel, message: string): void {
    if (this.shouldLog(level)) {
      const timestamp = new Date().toISOString();
      console[level](`[${timestamp}] [${this.context}] ${message}`);
    }
  }
}

export default LoggingUtil;
export { DEFAULT_LOG_LEVEL, LOG_LEVELS };
export type { LogLevel };
